import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";
import { Stroke, Style, Fill, Circle as CircleStyle } from "ol/style";

const chgeSource = new VectorSource({
  url: "map_resources/chge_zones.geojson",
  format: new GeoJSON(),
});

const chge_layer = new VectorLayer({
  source: chgeSource,
  style: new Style({
    stroke: new Stroke({ color: "#38b3c9", width: 1 }),

  }),
});
chge_layer.set("name", "chge_layer");
chge_layer.set("interactive", false)

const nysSource = new VectorSource({
  url: "map_resources/nystate.geojson",
  format: new GeoJSON(),
});

const nys_layer = new VectorLayer({
  source: nysSource,
  style: new Style({
    stroke: new Stroke({ color: "#c3d6eb", width: 2 }),

  }),
});
nys_layer.set("name", "nys_layer");


const nyscountiesSource = new VectorSource({
  url: "map_resources/nycounties.geojson",
  format: new GeoJSON(),
});

const nyscounties_layer = new VectorLayer({
  source: nyscountiesSource,
  style: new Style({
    stroke: new Stroke({ color: "#8da1b6", width: 0.5 }),
  }),
});
nyscounties_layer.set("name", "nyscounties");


const US_States_Source = new VectorSource({
  url: "map_resources/US_States.geojson",
  format: new GeoJSON(),
});

const US_States_layer = new VectorLayer({
  source: US_States_Source,
  style: new Style({
    stroke: new Stroke({ color: "#d3e8ff", width: 1 }),
  }),
});
US_States_layer.set("name", "us_states");



const FDRA_Source = new VectorSource({
  url: "map_resources/NYFDRA.geojson",
  format: new GeoJSON(),

});

const FDRA_layer = new VectorLayer({
  source: FDRA_Source,
//   title: "FDRA Colors",
//   style: new Style({
//     stroke: new Stroke({ color: "#d3e8ff", width: 1 }),
//   }),
});
FDRA_layer.set("name", "fdras");
FDRA_layer.set("layerType", "fdra");



// Active fires layer:
const incidentSource = new VectorSource();

const incident_layer = new VectorLayer({
  source: incidentSource,
  style: (feature) => {
    const size = feature.get("IncidentSize") || 0;

    const radius = Math.max(6, Math.min(25, Math.log10(size + 1) * 4));

    return new Style({
      image: new CircleStyle({
        radius,
        fill: new Fill({ color: "rgba(255, 80, 0, 0.6)" }),
        stroke: new Stroke({ color: "#ffcc00", width: 1 }),
      }),
    });
  },
});
incident_layer.set("name", "incidents");
incident_layer.set("layerType", "incidents");


export const updateIncidentLayer = async (layer) => {
  const url =
    "https://services3.arcgis.com/T4QMspbfLg3qTGWY/arcgis/rest/services/WFIGS_Incident_Locations_Current/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson";

  const res = await fetch(url);
  const data = await res.json();

  const features = new GeoJSON().readFeatures(data, {
    featureProjection: "EPSG:3857",
  });
  features.forEach((feature) => {
    const props = feature.getProperties();

    feature.set("type", "incident");

    feature.set("IncidentName", props.IncidentName || props.IncidentName || "Unknown");

    feature.set("IncidentSize", props.IncidentSize || props.IncidentSizeAcres);

    feature.set("PercentContained", props.PercentContained ?? props.PCTContained);
  });
  layer.getSource().clear();
  layer.getSource().addFeatures(features);

};

export const base_layers = [chge_layer, nys_layer, nyscounties_layer, US_States_layer, FDRA_layer, incident_layer];
